import React from 'react';
import { Button, Table } from 'reactstrap';

import { Modal, ModalOpen, ModalClose } from '../Modal';

function SplitV2FallbackApplyModalInit(data) {
	ModalOpen('SplitV2FallbackApplyModal', data);
}

const valueOrDash = (v) => {
	if (v === null || v === undefined || v === '') return '-';
	return String(v);
};

const SplitV2FallbackApplyModalContent = (props) => {
	if (!props) return null;

	return (
		<div className="ad_trade_bg p-4">
			<div className="modal-body">
				<Table striped bordered hover>
					<tbody>
						<tr>
							<td>Aktie</td>
							<td>{valueOrDash(props.StockLabel)}</td>
						</tr>
						<tr>
							<td>Række-status</td>
							<td>{valueOrDash(props.RowStatus)}</td>
						</tr>
						<tr>
							<td>Anvendelsesstatus</td>
							<td>{valueOrDash(props.ApplyStatus)}</td>
						</tr>
						<tr>
							<td>Behandlet</td>
							<td>{valueOrDash(props.Processed)}</td>
						</tr>
						<tr>
							<td>Fejlet</td>
							<td>{valueOrDash(props.Failed)}</td>
						</tr>
						<tr>
							<td>Lukkede positioner</td>
							<td>{valueOrDash(props.ClosedPositions)}</td>
						</tr>
						<tr>
							<td>Sprunget over IDs</td>
							<td style={{ whiteSpace: 'pre-wrap' }}>{valueOrDash(props.SkippedIDs)}</td>
						</tr>
						<tr>
							<td>Fejlede IDs</td>
							<td style={{ whiteSpace: 'pre-wrap' }}>{valueOrDash(props.FailedIDs)}</td>
						</tr>
						<tr>
							<td>Bruger-id (actor)</td>
							<td>{valueOrDash(props.ActorUserID)}</td>
						</tr>
						<tr>
							<td>Anvendt tidspunkt</td>
							<td>{valueOrDash(props.AppliedTs)}</td>
						</tr>
						<tr>
							<td>Note</td>
							<td style={{ whiteSpace: 'pre-wrap' }}>{valueOrDash(props.Note)}</td>
						</tr>
					</tbody>
				</Table>
			</div>
			<div className="modal-footer">
				<Button onClick={ModalClose} color="secondary">Luk</Button>
			</div>
		</div>
	);
};

class SplitV2FallbackApplyModal extends Modal {
	allow_close_via_ui() {
		return true;
	}

	mrender() {
		return <SplitV2FallbackApplyModalContent {...this.props} />;
	}

	get_name() {
		return 'SplitV2FallbackApplyModal';
	}

	get_fullscreen() {
		return false;
	}
}

export {
	SplitV2FallbackApplyModalInit,
	SplitV2FallbackApplyModal,
};



// WEBPACK FOOTER //
// ./src/c/SplitV2FallbackApplyModal.js